import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const PricePoints: React.FC<CreateIconComponentProps> = (props) => (
  <CreateIconComponent viewBox="0 0 43 43" {...props}>
    <path fillOpacity=".01" d="M0 3h40v40H0z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M33.12 7.885L21.435 6.692a2.024 2.024 0 00-1.636.583L2.626 24.447c-.79.79-.79 2.071 0 2.862l12.879 12.879c.79.79 2.072.79 2.862 0l17.172-17.172c.43-.43.644-1.032.582-1.637L34.93 9.693a2.024 2.024 0 00-1.808-1.808zm-2.05 3.858l.927 9.09-15.061 15.06L6.919 25.878 21.98 10.815l9.09.928zm-3.36 9.166a4.048 4.048 0 11-5.724-5.724 4.048 4.048 0 015.724 5.724z"
    />
  </CreateIconComponent>
);

export default PricePoints;
